import type { TokenStats } from './.server/rateLimit';
import { clientFetch } from '~/lib/.client/fetch';

export async function getUserRateLimit(options?: { signal?: AbortSignal }) {
  const response = await clientFetch(`/api/rate-limits/user`, {
    signal: options?.signal,
  });

  if (!response.ok) {
    throw new Error('Failed to fetch rate limit');
  }

  return response.json<TokenStats>();
}

export async function getOrganizationRateLimit(organizationId: number, options?: { signal?: AbortSignal }) {
  const response = await clientFetch(`/api/rate-limits/teams/${organizationId}`, {
    signal: options?.signal,
  });

  if (!response.ok) {
    throw new Error('Failed to fetch rate limit');
  }

  return response.json<TokenStats>();
}
